import React, { useRef, useCallback } from 'react';
import { observer, useLocalStore } from 'mobx-react';
import Styles from './index.module.scss';
import EditorContainer from '@/pages/document/component/RichEditor';
import { getHeaderList } from '@/pages/document/utils';

const Editor: React.FC<any> = () => {
  const ref = useRef(null);
  const authorRef = useRef(null);
  const State = useLocalStore(() => ({
    editor: null,
  }));
  const change = useCallback(() => {
    const html = getHeaderList((ref.current as any).cloneNode(true));
    (authorRef.current as any).innerHTML = html;
  }, []);
  const mounted = useCallback((editor) => {
    State.editor = editor;
  }, []);

  return (
    <div
      ref={ref}
      className={Styles.editorContainer}
    >
      <div
        className={Styles.textContainer}
        ref={ref}
      >
        <EditorContainer change={change} mounted={mounted} />
      </div>
      <div className={Styles.author}>
        <div className={Styles.authorlist} ref={authorRef} />
      </div>
    </div>
  );
};

export default React.memo(observer(Editor));
